import { styled } from '@mui/material';
import { Link } from 'react-router-dom';

const linkHoverBg = '#EBF6F7';

export const StyledActionPanelWrap = styled('div')({
  display: 'flex',
  flexWrap: 'wrap',
  gap: '0.935rem',
});

export const StyledFiltersLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minHeight: '42px',
  minWidth: '160px',
  padding: '0.5rem',
  border: `1px solid ${theme.palette.grey['300']}`,
  borderRadius: '2px',
}));

export const StyledFavoritesLink = styled(Link)(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'center',
  minWidth: '160px',
  fontWeight: 600,
  fontSize: theme.typography.button.fontSize,
  padding: '0.5rem',
  border: `1px solid ${theme.palette.grey['300']}`,
  borderRadius: '2px',
  color: theme.palette.primary.main,
  transition: 'border 0.5s, background-color 0.5s',
  textDecoration: 'none',

  '& > svg:first-of-type': {
    marginRight: '0.625rem',
  },

  '&:hover': {
    backgroundColor: linkHoverBg,
    border: `1px solid ${theme.palette.primary.main}`,
  },
}));
